export default {
  VEHICLE_CATEGORY_CLASS: 'main_box',
  GARAGE_ICON: '<rt-virtual template="icons/garage" />',
};
